import { isBrowser } from '../generic';

import { DEQ_ERROR_TYPES } from './deq.constants';

export const trackInputErrors = (inputType: string, errorText: string) => {
  if (!isBrowser || !window.aabAnalytics || !errorText || !inputType) return;

  window.aabAnalytics.push({
    command: 'ADD EVENT',
    name: 'error',
    data: {
      error_type: DEQ_ERROR_TYPES.user,
      error_code: DEQ_ERROR_TYPES.required,
      error_source: inputType,
      error_message: errorText.toLowerCase(),
    },
  });
};
